import React from "react";
//creo el componente funcional About que se mostrará en la ruta /about
export default function About(){
    return(
        <div>
            <h4>CONTACTAME</h4>
            <p>Email: facoogle@gmail.com</p>
            <p>Whatsapp: +54 3434671033</p>
        </div>
    )
}
